module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/fixed-header/fixed-header.component.css
// module id = ./src/app/examples/fixed-header/fixed-header.component.css
// module chunks = main